export default __webpack_public_path__ + "static/media/167.6d079be2.png";